import React from 'react';
import './App.css'; // Or the relevant CSS file if needed

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-line"></div>
      <div className="footer-content">
        <p>
          <br />
          &copy; 2025 WazzaScore. All rights reserved.
          <br />
        </p>
        <a href="/legal-stuff" className="footer-link">Legal stuff</a>
      </div>
    </footer>
  );
}

export default Footer;
